import { TextField,Typography } from '@mui/material';

export const PaginationSurvey = ({ questionsPerPage, setQuestionsPerPage }) => {
  const handleChange = (event) => {
    const value = parseInt(event.target.value, 10);
    if (!isNaN(value)) {
      const clamped = Math.max(3, Math.min(20, value));
      setQuestionsPerPage(clamped);
    }
  };

  return (
    <>
      <Typography
        variant="h6"
        style={{ fontWeight: 'bold', marginBottom: '15px' }}
      >
        Paginación de preguntas:
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Sólo se permiten valores entre 3 y 20.
      </Typography>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <p style={{ marginRight: '8px' }}>
          ¿Cuántas preguntas desea mostrar por página? (3 - 20)
        </p>
        <TextField
          type="number"
          value={questionsPerPage}
          onChange={handleChange}
          inputProps={{ min: 3, max: 20 }}
          size="small"
        />
      </div>
    </>
  );
};
